import Vue from 'vue';
import Vuex from 'vuex';

/* Modules */
import application from './modules/application';
import sso from './modules/sso';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		application,
		sso,
	},
	strict: false,
	plugins: [],
});
